import React, { LegacyRef, useState } from "react";
import toast from "react-hot-toast";
import { authApiService } from "../../../../api/api";
import { ReactComponent as PhotoIcon } from "../../../../assets/icons/modal/emptyPhoto.svg";
import { IBrandCreateDto } from "../../../../types/brands.type";
import SmallWhiteButton from "../../../buttons/WhiteButton/SmallWhiteButton";
import ModalBottomButtons from "../buttons/ModakBottomButtons/ModalBottomButtons";
import EditInput from "../inputs/EditInput/EditInput";
import styles from "./styles.module.scss";

interface Props {
  onClose: () => void;
  onApply: () => void;
}

const AddBrandForm: React.FC<Props> = (props) => {
  const [name, setName] = useState<string>("");
  const [note, setNote] = useState<string>("");
  const fileInputRef: LegacyRef<HTMLInputElement> | undefined =
    React.createRef();
  const [selectedImage, setSelectedImage] = useState<File | null>(null);
  const [previewUrl, setPreviewUrl] = useState<any>(null);
  const handleImageChange = (event: any) => {
    const file = event.target.files[0];
    setSelectedImage(file);

    const reader = new FileReader();
    reader.onloadend = () => {
      setPreviewUrl(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const removePhoto = () => {
    setSelectedImage(null);
    setPreviewUrl(null);
  };

  const onApply = async () => {
    if (!name) {
      toast.error('Поле "назва" обовʼязкове');
      return;
    }
    try {
      let avatar;
      if (selectedImage) {
        const formData = new FormData();
        formData.append("file", selectedImage);

        const response = await authApiService.uploadImage(formData);
        console.log(response);
        avatar = response.publicUrl;
      }

      const body: IBrandCreateDto = {
        name,
        description: note,
        imageUrl: avatar,
      };
      const response = await authApiService.createBrand(body);
      if (response) {
        props.onApply();
        props.onClose();
      }
    } catch (err) {
      console.error(err);
      toast.error("Сталась помилка. Спробуйте пізніше");
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.photoContainer}>
        {previewUrl ? (
          <img src={previewUrl} alt="employee" className={styles.image} />
        ) : (
          <PhotoIcon />
        )}
        <input
          id="file-upload"
          type="file"
          accept="image/*"
          onChange={handleImageChange}
          ref={fileInputRef}
          className={styles.input}
        />
        <SmallWhiteButton
          onClick={previewUrl ? removePhoto : handleButtonClick}
          title={previewUrl ? "Прибрати фото" : "Додати фото"}
        />
      </div>
      <form className={styles.form}>
        <EditInput
          value={name}
          setValue={(value) => setName(value)}
          title="Назва"
          isRequired={true}
        ></EditInput>
        <EditInput
          value={note}
          setValue={(value) => setNote(value)}
          title="Примітка"
          isRequired={false}
          isBig={true}
        />
      </form>
      <ModalBottomButtons
        onPressBack={props.onClose}
        onPressApply={onApply}
        backTitle="Назад"
        applyTitle="Додати бренд"
      />
    </div>
  );
};

export default AddBrandForm;
